import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargadorColores = null

const store = {
  state: {
    listaColores: {},
  },
  getters: {
    listaColores: state => {
      return state.listaColores
    },
  },
  mutations: {
    ASIGNA_CATALOGO_COLORES(state, listaColores) {
      state.listaColores = listaColores
    },
  },
  actions: {
    agregarColor({ getters }, color) {
      var idFranquicia = getters.usuario.id_franquicia
      let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection(FS_COLLECTIONS.CATALOGOS)
          .doc(FS_COLLECTIONS.PACIENTES)
      return docPath.set(color)
    },

   
    cargaCatalogoColores({ commit, getters }) {
      return new Promise((resolve,reject) => {
        var idFranquicia = getters.usuario.id_franquicia
        //console.log("id FRANQUICIA COLORES: "+idFranquicia)
        if (cargadorColores === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(idFranquicia)
            .collection(FS_COLLECTIONS.CATALOGOS)
            .doc(FS_COLLECTIONS.PACIENTES)
          cargadorColores = docPath.onSnapshot(doc => {
            //console.log('Current data colores: ', doc.data())
            commit('ASIGNA_CATALOGO_COLORES', doc.data())
            resolve()
          })
        }
      })
    },


  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/colores/colores.js